module.exports = __webpack_public_path__ + "img/sign-in-info.777c28d7.png";